import { useEffect, useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';
import { useModal } from 'mui-modal-provider';

import { OrderCard as OrderCardView } from './order-card';
import { OrderModal } from './order-modal';
import { IOrderCardContainerProps } from './order-card.models';
import { PotentialPointsType } from '../../../../../graphql/order/models/get-orders.models';
import { setOrderNumber } from '../../../../../graphql/order/order.cache';
import { v2026PP13312 } from '../../../../../constants/veeva';

export const OrderCard = ({
  orderNumber,
  orderStatus,
  orderType,
  orderDate,
  lastModifiedDateTime,
  orderProducts,
  id,
  brandsPoints,
  storeData,
  orderId,
  deliveryDate,
  oldDeliveryDate,
  bonus,
  bonusId,
  purchases,
  rating,
  productOwnerType,
  profileFirstName,
  profileLastName,
  profileIsActive,
  profileColorIndex,
  hasKidProfiles,
  orderPrice,
  deliveryInformation,
  potentialPoints,
}: IOrderCardContainerProps) => {
  const cashedOrderNumber = useReactiveVar(setOrderNumber);
  const points = useMemo(
    () => potentialPoints?.find(p => p.pointsType === PotentialPointsType.points)?.value,
    [potentialPoints],
  );
  const purchaseDate = useMemo(() => {
    if (purchases && purchases.length) {
      return purchases[0].purchaseDate;
    }
  }, [purchases]);

  const { showModal } = useModal();

  const handleOrderClick = () => {
    showModal(OrderModal, {
      orderNumber,
      products: orderProducts,
      storeData,
      points,
      orderStatus,
      orderId,
      deliveryDate,
      oldDeliveryDate,
      lastModifiedDateTime,
      bonus,
      bonusId,
      purchaseDate,
      rating,
      veevaNumber: v2026PP13312, // AERK-42968
      isVeevaSmall: true,
      orderPrice,
      orderType,
      deliveryInformation,
    });
  };

  useEffect(() => {
    if (orderNumber === cashedOrderNumber) {
      handleOrderClick();
    }
  }, [cashedOrderNumber, orderNumber]);

  return (
    <OrderCardView
      orderNumber={orderNumber}
      orderStatus={orderStatus}
      orderType={orderType}
      orderDate={orderDate}
      orderProducts={orderProducts}
      id={id}
      onClick={handleOrderClick}
      storeData={storeData}
      rating={rating}
      brandsPoints={brandsPoints}
      productOwnerType={productOwnerType}
      profileFirstName={profileFirstName}
      profileLastName={profileLastName}
      profileIsActive={profileIsActive}
      profileColorIndex={profileColorIndex}
      hasKidProfiles={hasKidProfiles}
    />
  );
};
